import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable()
export class LocalStorage {
    private _storage: any;

    constructor(@Inject(PLATFORM_ID) private _platformId: Object) {
        if (isPlatformBrowser(this._platformId)) {
            this._storage = localStorage;
        } else {
            this._storage = {
                _items: [],
                getItem(key: string) {
                    return this._items[key];
                },

                setItem(key: string, value: string) {
                    this._items[key] = value;
                },

                removeItem(key: string) {
                    delete this._items[key];
                }
            };
        }
    }

    public getItem(key: string): string {
        return this._storage.getItem(key);
    }

    public setItem(key: string, value: string) {
        this._storage.setItem(key, value);
    }

    public removeItem(key: string) {
        this._storage.removeItem(key);
    }
}